export const formatUrl = (url, includeDomain = false, filterUUID = true) => {
	if (!url) {
		return '';
	}

	const prefix = includeDomain ? process.env.GATSBY_DOMAIN_URL : '';

	// Remove trailing slashes
	let urlPaths = url.replace(/\/+$/, '').split('/');

	if (filterUUID) {
		urlPaths = urlPaths.filter(pathPartial => !pathPartial.startsWith('-'));
	}
	if (urlPaths[0] !== '') {
		urlPaths.unshift('');
	}

	return `${prefix}${urlPaths.join('/')}`;
};

export const LibraryPages = {
	LANDING: 'LANDING',
	CATEGORY: 'CATEGORY',
	ITEM: 'ITEM',
	ALL_CONTENT: 'ALL_CONTENT',
	ALL_TOOLS: 'ALL_TOOLS',
	ALL_LESSONS: 'ALL_LESSONS',
};

/**
 * Shared function that constructs library URL paths based on page type.
 * Used by both client-side and SSR versions of getLibraryUrlPrefix.
 *
 * @param {string} locale - The locale code (e.g., 'nl-nl', 'en-us')
 * @param {Object} translations - Object containing translated URL segments
 * @param {string} translations.library - Translated 'library' segment
 * @param {string} translations.items - Translated 'items' segment
 * @param {string} translations.tools - Translated 'tools' segment
 * @param {string} translations.lessons - Translated 'lessons' segment
 * @param {string} page - One of the LibraryPages constants
 * @returns {string} The constructed URL path
 */
export const constructLibraryUrlPath = (locale, translations, page) => {
	const urlParts = [locale, translations.library];

	switch (page) {
		case LibraryPages.LANDING:
		case LibraryPages.CATEGORY:
			break;
		case LibraryPages.ITEM:
		case LibraryPages.ALL_CONTENT:
			urlParts.push(translations.items);
			break;
		case LibraryPages.ALL_TOOLS:
			urlParts.push(translations.tools);
			break;
		case LibraryPages.ALL_LESSONS:
			urlParts.push(translations.lessons);
			break;
		default:
			break;
	}

	return urlParts.join('/');
};

/**
 * Client-side version of getLibraryUrlPrefix that uses useTranslation hook.
 * For SSR/Head contexts, use getLibraryUrlPrefixServer from ssr/library-head-helpers.js
 */
export const getLibraryUrlPrefix = (locale, t, page, lng) => {
	const lngOptions = lng ? { lng } : {};

	if (lng && lng === 'nl') {
		// NL translations are split between nl-nl and nl-be
		// use locale instead of lng for NL translations
		lngOptions.lng = locale;
	}

	// Prepare translations object for the shared function
	const translations = {
		library: t('gynzy-library-url-structure.library', lngOptions),
		items: t('gynzy-library-url-structure.items', lngOptions),
		tools: t('gynzy-library-url-structure.tools', lngOptions),
		lessons: t('gynzy-library-url-structure.lessons', lngOptions),
	};

	return constructLibraryUrlPath(locale, translations, page);
};
